"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hopsSdkJs = require("@hps/hops-sdk-js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("../Components/Flex"));
var _String = _interopRequireDefault(require("../Components/String"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Renders the details/summary of a `CheckoutBasketItem`-like object
 * 
 * @package HOPS
 * @subpackage Checkout
 * @copyright Heritage Opereations Processing Limited
 */const CheckoutBasketItemDetails = props => {
  /**
   * Render the item subtext details.
   * 
   * @return {ReactNode}
   */
  const renderSubtext = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
      color: "textSecondary",
      inline: true,
      noFlex: true,
      str: _hopsSdkJs.CheckoutBasketItem.getUiSubtext(props.item) || "",
      variant: "body2"
    });
  };
  const details = _hopsSdkJs.CheckoutBasketItem.getUiDetails(props.item);
  const subtext = renderSubtext();
  if (details?.length) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("details", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("summary", {
        title: "View Details",
        children: subtext
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
        gap: 0.25,
        pl: 0.75,
        mt: 0.25,
        children: details.map((detail, key) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
            inline: true,
            noFlex: true,
            noTrim: true,
            str: `${detail.label}${detail.value ? ": " : ""}`,
            variant: "body2",
            whiteSpace: "pre-wrap"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
            color: "textSecondary",
            inline: true,
            noFlex: true,
            str: detail.value,
            variant: "body2"
          })]
        }, key))
      })]
    });
  } else return subtext;
};
CheckoutBasketItemDetails.propTypes = {
  item: _propTypes.default.object
};
var _default = exports.default = CheckoutBasketItemDetails;